// todo: probably obsolete
export const AjaxLinks = {

    selectors: {
        ajaxLinksSelector: Array.prototype.slice.call(document.querySelectorAll('a.js-ajax')),
    },

    constants: {
        events: {
            onCall: 'ajaxOnCall',
        },
    },

    init: function() {
        let self = this;

        if (self.selectors.ajaxLinksSelector) {
            self.selectors.ajaxLinksSelector.forEach(function(link) {
                link.addEventListener('click', function (event) {
                    event.preventDefault();
                    self.call(link);
                    return false;
                });
            });
        }
    },

    call: function(_link) {
        let self = this;
        self.ajaxRequest(_link.href).then((result) => {self.successHandler(result, _link)}, self.errorHandler);
        self.callAttributeCallback(_link, self.constants.events.onCall);
    },

    callAttributeCallback: function(_link, _event) {
        if (typeof _link.dataset[_event] !== 'string') {
            return;
        }

        let callback = Function('"use strict"; ' +  _link.dataset[_event] + '; return;');
        callback();
    },

    ajaxRequest: function(_serviceURL) {
        let promiseObj = new Promise(function(resolve, reject) {
            let requestURL = _serviceURL;
            let request = new XMLHttpRequest();

            request.open('GET', requestURL);
            request.responseType = 'json';
            request.send();
            request.onreadystatechange = function() {
                if (request.readyState === 4){
                    if (request.status === 200){
                        resolve(request.response);
                    } else {
                        reject(request.status);
                        console.log("xhr failed");
                    }
                }
            }
        });
        return promiseObj;
    },

    successHandler: function(_result, _link) {},

    errorHandler: function(_statusCode) {
        console.error('Failed with status', _statusCode);
    },
};

AjaxLinks.init();
